// 小程序模块多语言配置
export const miniprogram = {
  'zh-CN': {
    // 授权开关
    forceLoginAuthSwitch: '强制登录授权开关',
    phoneAuthSwitch: '授权手机号开关',
    forceLoginAuthDesc: '开启后，未登录用户需登录后才可操作查看页面内容，拒绝登录则任何操作都会触发登录授权弹窗。关闭状态，未登录用户只可查看名片页相关内容，查看其他页面也需登录授权才可查看。',
    phoneAuthDesc: '开启后，未登录用户登录授权后并授权手机号后才可操作查看页面内容，拒绝授权则任何操作都会触发手机号授权弹窗。关闭状态，未登录用户登录授权后即可操作查看页面内容。',
    
    // 背景设置
    topBgColorConfig: '顶部背景色配置',
    selectTopBgColor: '选择顶部背景色',
    defaultBgColorNote: '注：默认白色背景色，黑色大于rgb(30,30,30).白色小于rgb（235,235,235）',
    bgColorNote: '除"媒体"页面外，"名片"、"商城"、"动态"、"官网"和"增值服务"页面的顶部背景色将根据设置的颜色显示',
    save: '保存',
    
    // CRM配置
    miniProgramName: '小程序名称',
    appId: 'APPID',
    authTime: '授权时间',
    appName: 'App名称',
    appSecret: 'AppSecret',
    pleaseEnterMiniProgramName: '请输入小程序名称',
    pleaseEnterAppId: '请输入小程序AppId',
    pleaseEnterAppSecret: '请输入小程序AppSecret',
    miniProgramNameDesc: '小程序的名称（请于微信小程序平台中的小程序名称保持一致，进入【设置】--【基本设置】--【小程序名称】查看）',
    appIdDesc: '登录小程序后台（mp.weixin.qq.com）进入【设置】--【开发设置】--【开发设置AppID,wx开头18位字符】）',
    appSecretDesc: '登录小程序后台（mp.weixin.qq.com）进入【设置】--【开发设置】--【AppSecret（小程序密钥)】--生成密钥（32位字符）',
    authorization: '授权',
    goToPersonalCenter: '请前往智能名片 【个人中心】-- 【用户ID】',
    userId: '用户ID',
    pleaseEnterUserId: '请输入智能名片用户ID',
    confirmSharedCustomers: '请确认所有客户都是共享客户才可进行转移',
    transferDataDesc: '目前只支持，转移 企业信息，产品信息，官网，共享客户这4种数据。不是支持员工转移。 员工只能重新加入新的小程序。',
    confirmTransfer: '确认转移',
    resetAuthorization: '重置授权',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    crmAuthSuccess: 'crm端授权成功',
    crmAuthFailed: 'crm端授权失败',
    transferSuccess: '转移成功',
    transferFailed: '转移失败',
    confirmTransferCompany: '确定要将企业移交给该用户吗？?',
    tip: '提示',
    confirm: '确定',
    cancel: '取消',
    pleaseEnterUserId: '请输入用户id',
    notAuthorized: '还未进行授权',
    
    // 支付配置
    wechatPayMerchantId: '微信支付商户号（mchid）',
    apiV2Key: 'APIv2密钥',
    apiV3Key: 'APIv3密钥（使用"商家转账到零钱"服务时必填）',
    certificateSerialNumber: '证书序列号（使用"商家转账到零钱"服务时必填）',
    apiCertificate: 'API证书（只能是p12证书，从微信支付商户后台生成并获取）',
    pleaseEnterMerchantId: '请输入微信支付商户号',
    pleaseEnterApiV2Key: '请输入APIv2密钥',
    pleaseEnterApiV3Key: '请输入APIv3密钥',
    pleaseEnterCertificateSerial: '请输入证书序列号',
    pleaseUploadApiCertificate: '请上传API证书',
    clickToUpload: '点击上传',
    submitInfo: '提交信息',
    deleteInfo: '删除信息',
    apiV3KeyDesc: '原"企业付款到零钱"已升级为"商家转账到零钱"，新开通商户必填"APIv3密钥"。',
    certificateSerialDesc: '登录商户平台【API安全】->【API证书】->【查看证书】，可查看商户API证书序列号。',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    checkDataComplete: '请检查资料是否完整',
    notSubmittedMerchantInfo: '还未提交微信支付商户信息',
    onlyOneCertificate: '只能上传一个证书文件',
    
    // 商品列表
    select: '选择',
    selectGoods: '选择商品',
    selectCategory: '选择分类',
    productName: '产品名称',
    category: '分类',
    price: '价格',
    originalPrice: '原价格',
    flashSalePrice: '秒杀价格',
    groupBuyPrice: '拼团价格',
    stock: '库存',
    totalSales: '总销量',
    publishTime: '发布时间',
    flashSaleTime: '秒杀活动时间',
    groupBuyTime: '拼团活动时间',
    serviceMethod: '服务方式',
    inStore: '到店',
    doorToDoor: '上门',
    inStoreDoorToDoor: '到店 - 上门',
    categoryName: '分类名称',
    goodsQuantity: '商品数量',
    noGoods: '暂无商品',
    noCategory: '暂无分类',
    needSetGoods: '需要设置商品',
    needSetCategory: '需要设置分类',
    goToSet: '去设置',
    cancel: '取消',
    confirm: '确认',
    pleaseSelectGoods: '请选择对应的商品或分类',
    sameGoodsError: '同模块下不能选择相同商品，请重新选择',
    
    // 跳转设置
    jumpTo: '跳转至',
    pleaseSelect: '请选择',
    no: '无',
    goodsCategory: '商品分类',
    ordinaryGoods: '普通商品',
    flashSaleGoods: '秒杀商品',
    groupBuyGoods: '拼团商品',
    distributionGoods: '分销商品',
    appointmentGoods: '预约商品',
    businessCardPage: '名片页',
    mediaPage: '媒体页',
    mallPage: '商城页',
    dynamicPage: '动态页',
    officialWebsitePage: '官网页',
    valueAddedServicesPage: '增值服务页',
    categoryNameLabel: '分类名称：',
    goodsQuantityLabel: '商品数量：',
    goodsNameLabel: '商品名称：',
    appointmentPriceLabel: '预约价格：',
    goodsPriceLabel: '商品价格：',
    
    // 公众号配置
    officialAccountName: '公众号名称',
    pleaseEnterOfficialAccountName: '请输入公众号名称',
    pleaseEnterOfficialAccountAppId: '请输入公众号AppId',
    pleaseEnterOfficialAccountAppSecret: '请输入公众号AppSecret',
    officialAccountNameDesc: '公众号的名称（请于微信公众号平台中的公众号名称保持一致，进入【设置】--【基本设置】--【公众号名称】查看）',
    officialAccountAppIdDesc: '登录公众号后台（mp.weixin.qq.com）进入【设置与开发】--【基本配置】--【公众号开发信息】--【开发者ID(AppID),wx开头18位字符】）',
    officialAccountAppSecretDesc: '登录公众号后台（mp.weixin.qq.com）进入【设置与开发】--【基本配置】--【公众号开发信息】--【开发者密码(AppSecret)】-- 生成后复制保存密钥（32位字符）',
    submit: '提交',
    checkDataComplete: '请检查资料是否完整',
    submitSuccess: '提交成功',
    notAuthorized: '还未进行授权',
    
    // 企业微信配置
    enterpriseWeChatAuthProcess: '企业微信授权流程',
    enterpriseWeChatAuthStep1: '① 在此填写相关企业微信配置信息。',
    enterpriseWeChatAuthStep2: '② 授权成功后，点击"扫码授权"，使用授权的企业微信进行扫码安装第三方应用(扫码授权)。',
    enterpriseWeChatAuthStep3: '③ 安装授权后，在"企业管理"--"企业成员"--"部门设置"点击"导入企微组织机构"即可导入企业微信组织机构信息（未在系统内创建名片的企业微信成员账号不可导入进名片系统内）。',
    configName: '配置名称',
    enterpriseId: '企业ID',
    appSecret: '应用Secret',
    authStatus: '授权状态',
    createTime: '创建时间',
    authorized: '已授权',
    notAuthorized: '未授权',
    pleaseEnterConfigName: '请输入配置名称',
    pleaseEnterEnterpriseId: '请输入企业ID',
    pleaseEnterAppSecret: '请输入自建应用Secret',
    configNameDesc: '登录企业微信（work.weixin.qq.com）进入【我的企业】--【企业信息中的最下面的企业ID，以ww开头18位字符】）',
    appSecretDesc: '登录企业微信（work.weixin.qq.com）进入【应用管理】--【自建】--【创建应用】--【进入创建的应用】--【Secret】--【查看】',
    save: '保存',
    reauthorize: '重新授权',
    resetConfig: '重置配置',
    resetEnterpriseWeChatInfo: '是否重置企业微信信息',
    resetEnterpriseWeChatDesc: '重置以后需要重新配置企业微信信息',
    resetSuccess: '重置成功！',
    resetFailed: '重置失败，请稍后重试',
    
    // 标签设置
    wechatMiniProgramMechanism: '因微信小程序机制，更改内容后需提交小程序审核，发布后才可生效',
    navigationModule: '导航模块',
    name: '名称',
    iconStyle: '图标样式',
    unselectedState: '未选中状态',
    selectedState: '选中状态',
    suggestUploadIcon: '建议上传81px * 81px的图标',
    displayPage: '展示页面',
    addNavigationTemplate: '添加导航模板',
    saveTab: '保存',
    businessCard: '名片',
    media: '媒体',
    mall: '商城',
    dynamic: '动态',
    officialWebsite: '官网',
    valueAddedServices: '增值服务',
    navigationInfoIncomplete: '导航栏信息不完整，请确认！',
    minTwoNavigation: '小程序最少需要两个导航栏！',
    maxFiveNavigation: '小程序最多五个导航栏！',
    uploadCorrectImageFormat: '请上传正确的图片格式',
    uploadImageSizeLimit: '上传图片大小不能超过10MB哦!',
    
    // 用户支付
    wechatPayMerchantId: '微信支付商户号（mchid）',
    apiV2Key: 'APIv2密钥',
    apiCertificate: 'API证书（只能是p12证书，从微信支付商户后台生成并获取）',
    pleaseEnterMerchantId: '请输入微信支付商户号',
    pleaseEnterApiV2Key: '请输入APIv2密钥',
    pleaseUploadApiCertificate: '请上传API证书',
    clickToUpload: '点击上传',
    submitInfo: '提交信息',
    deleteInfo: '删除信息',
    onlyOneCertificate: '只能上传一个证书文件',
    checkDataComplete: '请检查资料是否完整',
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    notSubmittedMerchantInfo: '还未提交微信支付商户信息',
    
    // 用户终端
    miniProgramName: '小程序名称',
    appName: 'App名称',
    pleaseEnterMiniProgramName: '请输入小程序名称',
    pleaseEnterAppId: '请输入小程序AppId',
    pleaseEnterAppSecret: '请输入小程序AppSecret',
    miniProgramNameDesc: '小程序的名称（请于微信小程序平台中的小程序名称保持一致，进入【设置】--【基本设置】--【小程序名称】查看）',
    appIdDesc: '登录小程序后台（mp.weixin.qq.com）进入【设置】--【开发设置】--【开发设置AppID,wx开头18位字符】）',
    appSecretDesc: '登录小程序后台（mp.weixin.qq.com）进入【设置】--【开发设置】--【AppSecret（小程序密钥)】--生成密钥（32位字符）',
    authorization: '授权',
    userEndAuthSuccess: '用户端授权成功',
    userEndAuthFailed: '用户端授权失败',
    notAuthorized: '还未进行授权',
    
    // 模板相关
    select: '选择',
    selectGoods: '选择商品',
    selectCategory: '选择分类',
    productName: '产品名称',
    category: '分类',
    price: '价格',
    originalPrice: '原价格',
    flashSalePrice: '秒杀价格',
    groupBuyPrice: '拼团价格',
    stock: '库存',
    totalSales: '总销量',
    publishTime: '发布时间',
    flashSaleTime: '秒杀活动时间',
    groupBuyTime: '拼团活动时间',
    serviceMethod: '服务方式',
    inStore: '到店',
    doorToDoor: '上门',
    inStoreDoorToDoor: '到店 - 上门',
    categoryName: '分类名称',
    goodsQuantity: '商品数量',
    noGoods: '暂无商品',
    noCategory: '暂无分类',
    needSetGoods: '需要设置商品',
    needSetCategory: '需要设置分类',
    goToSet: '去设置',
    cancel: '取消',
    confirm: '确认',
    pleaseSelectGoods: '请选择对应的商品或分类',
    sameGoodsError: '同模块下不能选择相同商品，请重新选择',
    
    // 跳转设置
    jumpTo: '跳转至',
    pleaseSelect: '请选择',
    no: '无',
    goodsCategory: '商品分类',
    ordinaryGoods: '普通商品',
    flashSaleGoods: '秒杀商品',
    groupBuyGoods: '拼团商品',
    distributionGoods: '分销商品',
    appointmentGoods: '预约商品',
    businessCardPage: '名片页',
    mediaPage: '媒体页',
    mallPage: '商城页',
    dynamicPage: '动态页',
    officialWebsitePage: '官网页',
    valueAddedServicesPage: '增值服务页',
    categoryNameLabel: '分类名称：',
    goodsQuantityLabel: '商品数量：',
    goodsNameLabel: '商品名称：',
    appointmentPriceLabel: '预约价格：',
    goodsPriceLabel: '商品价格：',
    
    // 倒计时
    day: '天',
    hour: '时',
    minute: '分',
    second: '秒',
    
    // 模板模块
    groupModule: '拼团模块',
    selectedModule: '精选模块',
    seckillModule: '秒杀模块',
    categoryModule: '分类模块',
    demoGoodsNote: '(图中所示商品为演示商品，请更改相关商品)',
    moduleName: '模块名称',
    goods: '商品',
    goodsName: '商品名称',
    goodsPrice: '商品价格',
    goodsImage: '商品图片',
    goodsDescription: '商品描述',
    pleaseEnterContent: '请输入内容',
    selectGroupGoods: '选择拼团商品',
    selectSelectedGoods: '选择精选商品',
    selectSeckillGoods: '选择秒杀商品',
    
    // 样式设置
    displayStyle: '展示样式',
    styleSettings: '样式设置',
    iconUploadNote: '图标上传宽度为100*100px的效果最佳',
    titleSettings: '标题设置',
    jumpSettings: '跳转设置',
    iconReset: '图标重置',
    uploadCorrectImageFormat: '请上传正确的图片格式',
    uploadImageSizeLimit: '上传图片大小不能超过10MB哦!',
    
    // 错误提示
    seckillMinError: '秒杀商品不得少于三个',
    seckillMaxError: '秒杀商品不得多于六个',
    goodsAlreadySelected: '该商品已经选择，请选择其他商品',
    
    // 新增的键值对
    mobilePhone: '手机',
    tablet: '平板',
    computer: '电脑',
    camera: '相机',
    refrigerator: '冰箱',
    washingMachine: '洗衣机',
    kitchenAppliances: '厨卫电器',
    furniture: '家具',
    television: '电视机',
    airConditioner: '空调',
    businessCard: '名片',
    media: '媒体',
    dynamic: '动态',
    officialWebsite: '官网',
    personalCare: '个人护理',
    householdCleaning: '家务清洁',
    maternalInfant: '母婴用品',
    protectiveEquipment: '防护用品',
    homeTextiles: '家纺用品',
    leisureSnacks: '休闲零食',
    limitedTimeFlashSale: '限时秒杀',
    groupBuyRush: '拼团抢购',
    epidemicPreventionMask: '防疫口罩',
    miniUmbrella: '迷你雨伞',
    todayRecommendModule: '今日推荐模块',
    qualityTowel: '精品毛巾',
    sweepingRobot: '扫地机器人',
    deliciousSnacks: '好吃零食',
    summerNewTshirt: '夏季新款T恤',
    recommendedGoods: '推荐好货',
    superDeliciousSecretRecipeCookies: '超级美味祖传秘方好吃饼干',
    broom: '扫把',
    insStyleWhiteTransparentFairyCurtains: 'ins风白色半透明仙女窗帘',
    clothing: '衣服',
    pants: '裤子',
    hat: '帽子',
    shoes: '鞋子',
    specialPriceFlashSale: '特价秒杀',
    liningChinaLiningShortSleeve: 'Lining中国李宁短袖',
    liningLiningSportsShoes: 'Lining李宁运动鞋',
    loosePrintTshirt: '宽松印花T恤',
    qualityRecommendation: '精品推荐',
    liningHighTopShoes: '李宁高帮鞋',
    wearItAndYouWillBeTheMostHandsomeGuy: '穿上它，你就是最靓的仔',
    blackTrendyShoes: '黑色潮鞋',
    coolTrendyShoesWorthHavingLightweightComfortableCasualSports: '冷酷潮鞋，值得拥有轻便舒适，休闲运动',
    restoreDefault: '恢复默认',
    carousel: '轮播图',
    imageUploadNote750x324: '建议上传750px * 324px的图片效果最佳',
    promotion618: '618',
    midYearPromotion: '年中促销',
    discountCoupon: '满减卷',
    discountGoodGiftLimitedTime: '优惠好礼、送完即止',
    topsAndOuterwear: '上衣外套',
    qualityBags: '精品包包',
    trendyClothing: '潮流服饰',
    jewelry: '珠宝首饰',
    officeFurniture: '办公家具',
    deliciousFoodAndWine: '美食美酒',
    booksAndEducation: '图书文教',
    beautyAndSkincare: '美妆护肤',
    topGoods: 'TOP好货',
    goodGoodsPromotionDirectDiscount: '好货促销.爆款直降',
    trendyCoat: '潮流大衣',
    fashionHat: '时尚帽子',
    trendyShortSleeve: '潮流短袖',
    hikingShoes: '登山鞋',
    newBigBrand: 'NEW大牌',
    midYearPromotionGoodThingsAward: '年中促销·好物大赏',
    huaweiPhone: '华为手机',
    fastFaster: '快，更快',
    superStrongCooling: '超强制冷',
    thaiFragrantRice: '泰国香米',
    deliciousAndAffordable: '好吃不贵',
    alreadyAtTopCannotMoveUp: '已经处于置顶，无法上移',
    alreadyAtBottomCannotMoveDown: '已经触底，无法下移',
    couponNotSet: '优惠券未设置',
    seckillModuleNotSetGoods: '秒杀模块未设置商品',
    boutiqueModuleNotSetGoods: '精选模块未设置商品',
    saveSuccessful: '保存成功',
    resetSuccessful: '重置成功！',
    resetFailedPleaseTryAgainLater: '重置失败，请稍后重试',
    recommendModule: '推荐模块',
    leftModule: '左侧模块',
    rightModule: '右侧模块',
    imageUploadNoteSize: '建议上传{size}px的图片效果最佳',
    hotSaleExplosive: '热销爆款',
    superValueDiscount: '超值优惠',
    today50Off: '今天5折',
    groupBuyDiscount: '拼团优惠',
    familyEssential: '家庭必备',
    qualityCamera: '精品相机',
    iphone11: '苹果 11',
    xiaomiK40: '小米 K40',
    phoneCase: '手机壳',
    phoneBracelet: '手机手环',
    xiaomiRefrigerator: '小米冰箱',
    router: '路由器',
    diningTable: '餐桌',
    qualityBed: '精品大床',
    mallDataIncomplete: '商城数据未完整',
    userEnd: '用户端',
    crmEnd: 'crm端',
    userEndPayment: '用户端支付',
    crmPayment: 'crm支付',
    officialAccountSettings: '公众号设置',
    loginSettings: '登录设置',
    enterpriseWeChat: '企业微信',
    resetAuthorizationInfo: '是否重置授权信息',
    resetNeedReconfigureMiniProgramInfo: '重置以后需要重新配置小程序信息',
    bottomNavigation: '底部导航',
    topBackgroundColorConfig: '顶部背景色配置',
    
    // 新增的键值对
    moduleDisplay: '模块展示',
    mallTemplate: '商城模板',
    appointmentTemplate: '预约模板',
    canSelectAllOrOnlyShowMallModule: '可全选，可只展示"商城模块"',
    mallModule: '商城模块',
    moduleName: '模块名称',
    moduleStyle: '模块样式',
    currentStyle: '当前样式',
    changeStyle: '更换样式',
    topCarousel: '顶部轮播图',
    imageUploadNote750x422: '建议上传750px * 422px的图片效果最佳',
    addImage: '添加图片',
    appointmentModule: '预约模块',
    save: '保存',
    selectStyle: '选择样式',
    styleSelectionDescription: '您可根据选择以下任一一款样式装饰您的商城，除简约模式外，其他样式首次都需编辑后才可使用。',
    editContent: '编辑内容',
    cancel: '取消',
    confirm: '确认',
    productMall: '产品商城',
    appointmentService: '预约服务',
    simpleMode: '简约模式',
    comprehensiveEcommerce: '综合电商',
    festivalDiscount: '节日优惠',
    dailyNecessities: '日用百货',
    digitalAppliances: '数码家电',
    no: '无',
    ordinaryGoods: '普通商品',
    flashSaleGoods: '秒杀商品',
    groupBuyGoods: '拼团商品',
    distributionGoods: '分销商品',
    businessCardPage: '名片页',
    mediaPage: '媒体页',
    mallPage: '商城页',
    dynamicPage: '动态页',
    officialWebsitePage: '官网页',
    templateNeedConfigureContentBeforeSave: '该模板需配置好内容后才可以保存，请点击"编辑内容"，配置好模板后再保存！',
    uploadCorrectImageFormat: '请上传正确的图片格式',
    uploadImageSizeLimit: '上传图片大小不能超过10MB哦!',
    saveSuccessful: '保存成功',
  },
  'zh-TW': {
    // 授权开关
    forceLoginAuthSwitch: '強制登錄授權開關',
    phoneAuthSwitch: '授權手機號開關',
    forceLoginAuthDesc: '開啟後，未登錄用戶需登錄後才可操作查看頁面內容，拒絕登錄則任何操作都會觸發登錄授權彈窗。關閉狀態，未登錄用戶只可查看名片頁相關內容，查看其他頁面也需登錄授權才可查看。',
    phoneAuthDesc: '開啟後，未登錄用戶登錄授權後並授權手機號後才可操作查看頁面內容，拒絕授權則任何操作都會觸發手機號授權彈窗。關閉狀態，未登錄用戶登錄授權後即可操作查看頁面內容。',
    
    // 背景设置
    topBgColorConfig: '頂部背景色配置',
    selectTopBgColor: '選擇頂部背景色',
    defaultBgColorNote: '注：默認白色背景色，黑色大於rgb(30,30,30).白色小於rgb（235,235,235）',
    bgColorNote: '除"媒體"頁面外，"名片"、"商城"、"動態"、"官網"和"增值服務"頁面的頂部背景色將根據設置的顏色顯示',
    save: '保存',
    
    // CRM配置
    miniProgramName: '小程序名稱',
    appId: 'APPID',
    authTime: '授權時間',
    appName: 'App名稱',
    appSecret: 'AppSecret',
    pleaseEnterMiniProgramName: '請輸入小程序名稱',
    pleaseEnterAppId: '請輸入小程序AppId',
    pleaseEnterAppSecret: '請輸入小程序AppSecret',
    miniProgramNameDesc: '小程序的名稱（請於微信小程序平台中的小程序名稱保持一致，進入【設置】--【基本設置】--【小程序名稱】查看）',
    appIdDesc: '登錄小程序後台（mp.weixin.qq.com）進入【設置】--【開發設置】--【開發設置AppID,wx開頭18位字符】）',
    appSecretDesc: '登錄小程序後台（mp.weixin.qq.com）進入【設置】--【開發設置】--【AppSecret（小程序密鑰)】--生成密鑰（32位字符）',
    authorization: '授權',
    goToPersonalCenter: '請前往智能名片 【個人中心】-- 【用戶ID】',
    userId: '用戶ID',
    pleaseEnterUserId: '請輸入智能名片用戶ID',
    confirmSharedCustomers: '請確認所有客戶都是共享客戶才可進行轉移',
    transferDataDesc: '目前只支持，轉移 企業信息，產品信息，官網，共享客戶這4種數據。不是支持員工轉移。 員工只能重新加入新的小程序。',
    confirmTransfer: '確認轉移',
    resetAuthorization: '重置授權',
    operationSuccess: '操作成功',
    operationFailed: '操作失敗',
    crmAuthSuccess: 'crm端授權成功',
    crmAuthFailed: 'crm端授權失敗',
    transferSuccess: '轉移成功',
    transferFailed: '轉移失敗',
    confirmTransferCompany: '確定要將企業移交給該用戶嗎？?',
    tip: '提示',
    confirm: '確定',
    cancel: '取消',
    pleaseEnterUserId: '請輸入用戶id',
    notAuthorized: '還未進行授權',
    
    // 支付配置
    wechatPayMerchantId: '微信支付商戶號（mchid）',
    apiV2Key: 'APIv2密鑰',
    apiV3Key: 'APIv3密鑰（使用"商家轉賬到零錢"服務時必填）',
    certificateSerialNumber: '證書序列號（使用"商家轉賬到零錢"服務時必填）',
    apiCertificate: 'API證書（只能是p12證書，從微信支付商戶後台生成並獲取）',
    pleaseEnterMerchantId: '請輸入微信支付商戶號',
    pleaseEnterApiV2Key: '請輸入APIv2密鑰',
    pleaseEnterApiV3Key: '請輸入APIv3密鑰',
    pleaseEnterCertificateSerial: '請輸入證書序列號',
    pleaseUploadApiCertificate: '請上傳API證書',
    clickToUpload: '點擊上傳',
    submitInfo: '提交信息',
    deleteInfo: '刪除信息',
    apiV3KeyDesc: '原"企業付款到零錢"已升級為"商家轉賬到零錢"，新開通商戶必填"APIv3密鑰"。',
    certificateSerialDesc: '登錄商戶平台【API安全】->【API證書】->【查看證書】，可查看商戶API證書序列號。',
    submitSuccess: '提交成功',
    submitFailed: '提交失敗',
    checkDataComplete: '請檢查資料是否完整',
    notSubmittedMerchantInfo: '還未提交微信支付商戶信息',
    onlyOneCertificate: '只能上傳一個證書文件',
    
    // 商品列表
    select: '選擇',
    selectGoods: '選擇商品',
    selectCategory: '選擇分類',
    productName: '產品名稱',
    category: '分類',
    price: '價格',
    originalPrice: '原價格',
    flashSalePrice: '秒殺價格',
    groupBuyPrice: '拼團價格',
    stock: '庫存',
    totalSales: '總銷量',
    publishTime: '發布時間',
    flashSaleTime: '秒殺活動時間',
    groupBuyTime: '拼團活動時間',
    serviceMethod: '服務方式',
    inStore: '到店',
    doorToDoor: '上門',
    inStoreDoorToDoor: '到店 - 上門',
    categoryName: '分類名稱',
    goodsQuantity: '商品數量',
    noGoods: '暫無商品',
    noCategory: '暫無分類',
    needSetGoods: '需要設置商品',
    needSetCategory: '需要設置分類',
    goToSet: '去設置',
    cancel: '取消',
    confirm: '確認',
    pleaseSelectGoods: '請選擇對應的商品或分類',
    sameGoodsError: '同模塊下不能選擇相同商品，請重新選擇',
    
    // 跳转设置
    jumpTo: '跳轉至',
    pleaseSelect: '請選擇',
    no: '無',
    goodsCategory: '商品分類',
    ordinaryGoods: '普通商品',
    flashSaleGoods: '秒殺商品',
    groupBuyGoods: '拼團商品',
    distributionGoods: '分銷商品',
    appointmentGoods: '預約商品',
    businessCardPage: '名片頁',
    mediaPage: '媒體頁',
    mallPage: '商城頁',
    dynamicPage: '動態頁',
    officialWebsitePage: '官網頁',
    valueAddedServicesPage: '增值服務頁',
    categoryNameLabel: '分類名稱：',
    goodsQuantityLabel: '商品數量：',
    goodsNameLabel: '商品名稱：',
    appointmentPriceLabel: '預約價格：',
    goodsPriceLabel: '商品價格：',
    
    // 公众号配置
    officialAccountName: '公眾號名稱',
    pleaseEnterOfficialAccountName: '請輸入公眾號名稱',
    pleaseEnterOfficialAccountAppId: '請輸入公眾號AppId',
    pleaseEnterOfficialAccountAppSecret: '請輸入公眾號AppSecret',
    officialAccountNameDesc: '公眾號的名稱（請於微信公眾號平台中的公眾號名稱保持一致，進入【設置】--【基本設置】--【公眾號名稱】查看）',
    officialAccountAppIdDesc: '登錄公眾號後台（mp.weixin.qq.com）進入【設置與開發】--【基本配置】--【公眾號開發信息】--【開發者ID(AppID),wx開頭18位字符】）',
    officialAccountAppSecretDesc: '登錄公眾號後台（mp.weixin.qq.com）進入【設置與開發】--【基本配置】--【公眾號開發信息】--【開發者密碼(AppSecret)】-- 生成後複製保存密鑰（32位字符）',
    submit: '提交',
    checkDataComplete: '請檢查資料是否完整',
    submitSuccess: '提交成功',
    notAuthorized: '還未進行授權',
    
    // 企业微信配置
    enterpriseWeChatAuthProcess: '企業微信授權流程',
    enterpriseWeChatAuthStep1: '① 在此填寫相關企業微信配置信息。',
    enterpriseWeChatAuthStep2: '② 授權成功後，點擊"掃碼授權"，使用授權的企業微信進行掃碼安裝第三方應用(掃碼授權)。',
    enterpriseWeChatAuthStep3: '③ 安裝授權後，在"企業管理"--"企業成員"--"部門設置"點擊"導入企微組織機構"即可導入企業微信組織機構信息（未在系統內創建名片的企業微信成員賬號不可導入進名片系統內）。',
    configName: '配置名稱',
    enterpriseId: '企業ID',
    appSecret: '應用Secret',
    authStatus: '授權狀態',
    createTime: '創建時間',
    authorized: '已授權',
    notAuthorized: '未授權',
    pleaseEnterConfigName: '請輸入配置名稱',
    pleaseEnterEnterpriseId: '請輸入企業ID',
    pleaseEnterAppSecret: '請輸入自建應用Secret',
    configNameDesc: '登錄企業微信（work.weixin.qq.com）進入【我的企業】--【企業信息中的最下面的企業ID，以ww開頭18位字符】）',
    appSecretDesc: '登錄企業微信（work.weixin.qq.com）進入【應用管理】--【自建】--【自建】--【創建應用】--【進入創建的應用】--【Secret】--【查看】',
    save: '保存',
    reauthorize: '重新授權',
    resetConfig: '重置配置',
    resetEnterpriseWeChatInfo: '是否重置企業微信信息',
    resetEnterpriseWeChatDesc: '重置以後需要重新配置企業微信信息',
    resetSuccess: '重置成功！',
    resetFailed: '重置失敗，請稍後重試',
    
    // 标签设置
    wechatMiniProgramMechanism: '因微信小程序機制，更改內容後需提交小程序審核，發布後才可生效',
    navigationModule: '導航模塊',
    name: '名稱',
    iconStyle: '圖標樣式',
    unselectedState: '未選中狀態',
    selectedState: '選中狀態',
    suggestUploadIcon: '建議上傳81px * 81px的圖標',
    displayPage: '展示頁面',
    addNavigationTemplate: '添加導航模板',
    saveTab: '保存',
    businessCard: '名片',
    media: '媒體',
    mall: '商城',
    dynamic: '動態',
    officialWebsite: '官網',
    valueAddedServices: '增值服務',
    navigationInfoIncomplete: '導航欄信息不完整，請確認！',
    minTwoNavigation: '小程序最少需要兩個導航欄！',
    maxFiveNavigation: '小程序最多五個導航欄！',
    uploadCorrectImageFormat: '請上傳正確的圖片格式',
    uploadImageSizeLimit: '上傳圖片大小不能超過10MB哦!',
    
    // 用户支付
    wechatPayMerchantId: '微信支付商戶號（mchid）',
    apiV2Key: 'APIv2密鑰',
    apiCertificate: 'API證書（只能是p12證書，從微信支付商戶後台生成並獲取）',
    pleaseEnterMerchantId: '請輸入微信支付商戶號',
    pleaseEnterApiV2Key: '請輸入APIv2密鑰',
    pleaseUploadApiCertificate: '請上傳API證書',
    clickToUpload: '點擊上傳',
    submitInfo: '提交信息',
    deleteInfo: '刪除信息',
    onlyOneCertificate: '只能上傳一個證書文件',
    checkDataComplete: '請檢查資料是否完整',
    submitSuccess: '提交成功',
    submitFailed: '提交失敗',
    notSubmittedMerchantInfo: '還未提交微信支付商戶信息',
    
    // 用户终端
    miniProgramName: '小程序名稱',
    appName: 'App名稱',
    pleaseEnterMiniProgramName: '請輸入小程序名稱',
    pleaseEnterAppId: '請輸入小程序AppId',
    pleaseEnterAppSecret: '請輸入小程序AppSecret',
    miniProgramNameDesc: '小程序的名稱（請於微信小程序平台中的小程序名稱保持一致，進入【設置】--【基本設置】--【小程序名稱】查看）',
    appIdDesc: '登錄小程序後台（mp.weixin.qq.com）進入【設置】--【開發設置】--【開發設置AppID,wx開頭18位字符】）',
    appSecretDesc: '登錄小程序後台（mp.weixin.qq.com）進入【設置】--【開發設置】--【AppSecret（小程序密鑰)】--生成密鑰（32位字符）',
    authorization: '授權',
    userEndAuthSuccess: '用戶端授權成功',
    userEndAuthFailed: '用戶端授權失敗',
    notAuthorized: '還未進行授權',
    
    // 模板相关
    select: '選擇',
    selectGoods: '選擇商品',
    selectCategory: '選擇分類',
    productName: '產品名稱',
    category: '分類',
    price: '價格',
    originalPrice: '原價格',
    flashSalePrice: '秒殺價格',
    groupBuyPrice: '拼團價格',
    stock: '庫存',
    totalSales: '總銷量',
    publishTime: '發布時間',
    flashSaleTime: '秒殺活動時間',
    groupBuyTime: '拼團活動時間',
    serviceMethod: '服務方式',
    inStore: '到店',
    doorToDoor: '上門',
    inStoreDoorToDoor: '到店 - 上門',
    categoryName: '分類名稱',
    goodsQuantity: '商品數量',
    noGoods: '暫無商品',
    noCategory: '暫無分類',
    needSetGoods: '需要設置商品',
    needSetCategory: '需要設置分類',
    goToSet: '去設置',
    cancel: '取消',
    confirm: '確認',
    pleaseSelectGoods: '請選擇對應的商品或分類',
    sameGoodsError: '同模塊下不能選擇相同商品，請重新選擇',
    
    // 跳转设置
    jumpTo: '跳轉至',
    pleaseSelect: '請選擇',
    no: '無',
    goodsCategory: '商品分類',
    ordinaryGoods: '普通商品',
    flashSaleGoods: '秒殺商品',
    groupBuyGoods: '拼團商品',
    distributionGoods: '分銷商品',
    appointmentGoods: '預約商品',
    businessCardPage: '名片頁',
    mediaPage: '媒體頁',
    mallPage: '商城頁',
    dynamicPage: '動態頁',
    officialWebsitePage: '官網頁',
    valueAddedServicesPage: '增值服務頁',
    categoryNameLabel: '分類名稱：',
    goodsQuantityLabel: '商品數量：',
    goodsNameLabel: '商品名稱：',
    appointmentPriceLabel: '預約價格：',
    goodsPriceLabel: '商品價格：',
    
    // 倒计时
    day: '天',
    hour: '時',
    minute: '分',
    second: '秒',
    
    // 模板模块
    groupModule: '拼團模塊',
    selectedModule: '精選模塊',
    seckillModule: '秒殺模塊',
    categoryModule: '分類模塊',
    demoGoodsNote: '(圖中所示商品為演示商品，請更改相關商品)',
    moduleName: '模塊名稱',
    goods: '商品',
    goodsName: '商品名稱',
    goodsPrice: '商品價格',
    goodsImage: '商品圖片',
    goodsDescription: '商品描述',
    pleaseEnterContent: '請輸入內容',
    selectGroupGoods: '選擇拼團商品',
    selectSelectedGoods: '選擇精選商品',
    selectSeckillGoods: '選擇秒殺商品',
    
    // 样式设置
    displayStyle: '展示樣式',
    styleSettings: '樣式設置',
    iconUploadNote: '圖標上傳寬度為100*100px的效果最佳',
    titleSettings: '標題設置',
    jumpSettings: '跳轉設置',
    iconReset: '圖標重置',
    uploadCorrectImageFormat: '請上傳正確的圖片格式',
    uploadImageSizeLimit: '上傳圖片大小不能超過10MB哦!',
    
    // 错误提示
    seckillMinError: '秒殺商品不得少於三個',
    seckillMaxError: '秒殺商品不得多於六個',
    goodsAlreadySelected: '該商品已經選擇，請選擇其他商品',
    
    // 新增的键值对
    mobilePhone: '手機',
    tablet: '平板',
    computer: '電腦',
    camera: '相機',
    refrigerator: '冰箱',
    washingMachine: '洗衣機',
    kitchenAppliances: '廚衛電器',
    furniture: '傢俱',
    television: '電視機',
    airConditioner: '空調',
    businessCard: '名片',
    media: '媒體',
    dynamic: '動態',
    officialWebsite: '官網',
    personalCare: '個人護理',
    householdCleaning: '家務清潔',
    maternalInfant: '母嬰用品',
    protectiveEquipment: '防護用品',
    homeTextiles: '家紡用品',
    leisureSnacks: '休閒零食',
    limitedTimeFlashSale: '限時秒殺',
    groupBuyRush: '拼團搶購',
    epidemicPreventionMask: '防疫口罩',
    miniUmbrella: '迷你雨傘',
    todayRecommendModule: '今日推薦模組',
    qualityTowel: '精品毛巾',
    sweepingRobot: '掃地機器人',
    deliciousSnacks: '好吃零食',
    summerNewTshirt: '夏季新款T恤',
    recommendedGoods: '推薦好貨',
    superDeliciousSecretRecipeCookies: '超級美味祖傳秘方好吃餅乾',
    broom: '掃把',
    insStyleWhiteTransparentFairyCurtains: 'ins風白色半透明仙女窗簾',
    clothing: '衣服',
    pants: '褲子',
    hat: '帽子',
    shoes: '鞋子',
    specialPriceFlashSale: '特價秒殺',
    liningChinaLiningShortSleeve: 'Lining中國李寧短袖',
    liningLiningSportsShoes: 'Lining李寧運動鞋',
    loosePrintTshirt: '寬鬆印花T恤',
    qualityRecommendation: '精品推薦',
    liningHighTopShoes: '李寧高幫鞋',
    wearItAndYouWillBeTheMostHandsomeGuy: '穿上它，你就是最靚的仔',
    blackTrendyShoes: '黑色潮鞋',
    coolTrendyShoesWorthHavingLightweightComfortableCasualSports: '冷酷潮鞋，值得擁有輕便舒適，休閒運動',
    restoreDefault: '恢復默認',
    carousel: '輪播圖',
    imageUploadNote750x324: '建議上傳750px * 324px的圖片效果最佳',
    promotion618: '618',
    midYearPromotion: '年中促銷',
    discountCoupon: '滿減卷',
    discountGoodGiftLimitedTime: '優惠好禮、送完即止',
    topsAndOuterwear: '上衣外套',
    qualityBags: '精品包包',
    trendyClothing: '潮流服飾',
    jewelry: '珠寶首飾',
    officeFurniture: '辦公傢俱',
    deliciousFoodAndWine: '美食美酒',
    booksAndEducation: '圖書文教',
    beautyAndSkincare: '美妝護膚',
    topGoods: 'TOP好貨',
    goodGoodsPromotionDirectDiscount: '好貨促銷.爆款直降',
    trendyCoat: '潮流大衣',
    fashionHat: '時尚帽子',
    trendyShortSleeve: '潮流短袖',
    hikingShoes: '登山鞋',
    newBigBrand: 'NEW大牌',
    midYearPromotionGoodThingsAward: '年中促銷·好物大賞',
    huaweiPhone: '華為手機',
    fastFaster: '快，更快',
    superStrongCooling: '超強製冷',
    thaiFragrantRice: '泰國香米',
    deliciousAndAffordable: '好吃不貴',
    alreadyAtTopCannotMoveUp: '已經處於置頂，無法上移',
    alreadyAtBottomCannotMoveDown: '已經觸底，無法下移',
    couponNotSet: '優惠券未設置',
    seckillModuleNotSetGoods: '秒殺模塊未設置商品',
    boutiqueModuleNotSetGoods: '精選模塊未設置商品',
    saveSuccessful: '保存成功',
    resetSuccessful: '重置成功！',
    resetFailedPleaseTryAgainLater: '重置失敗，請稍後重試',
    recommendModule: '推薦模塊',
    leftModule: '左側模塊',
    rightModule: '右側模塊',
    imageUploadNoteSize: '建議上傳{size}px的圖片效果最佳',
    hotSaleExplosive: '熱銷爆款',
    superValueDiscount: '超值優惠',
    today50Off: '今天5折',
    groupBuyDiscount: '拼團優惠',
    familyEssential: '家庭必備',
    qualityCamera: '精品相機',
    iphone11: '蘋果 11',
    xiaomiK40: '小米 K40',
    phoneCase: '手機殼',
    phoneBracelet: '手機手環',
    xiaomiRefrigerator: '小米冰箱',
    router: '路由器',
    diningTable: '餐桌',
    qualityBed: '精品大床',
    mallDataIncomplete: '商城數據未完整',
    userEnd: '用戶端',
    crmEnd: 'crm端',
    userEndPayment: '用戶端支付',
    crmPayment: 'crm支付',
    officialAccountSettings: '公眾號設置',
    loginSettings: '登錄設置',
    enterpriseWeChat: '企業微信',
    resetAuthorizationInfo: '是否重置授權信息',
    resetNeedReconfigureMiniProgramInfo: '重置以後需要重新配置小程序信息',
    bottomNavigation: '底部導航',
    topBackgroundColorConfig: '頂部背景色配置',
    
    // 新增的键值对
    moduleDisplay: '模組展示',
    mallTemplate: '商城模板',
    appointmentTemplate: '預約模板',
    canSelectAllOrOnlyShowMallModule: '可全選，可只展示"商城模組"',
    mallModule: '商城模組',
    moduleName: '模組名稱',
    moduleStyle: '模組樣式',
    currentStyle: '當前樣式',
    changeStyle: '更換樣式',
    topCarousel: '頂部輪播圖',
    imageUploadNote750x422: '建議上傳750px * 422px的圖片效果最佳',
    addImage: '添加圖片',
    appointmentModule: '預約模組',
    save: '保存',
    selectStyle: '選擇樣式',
    styleSelectionDescription: '您可根據選擇以下任一一款樣式裝飾您的商城，除簡約模式外，其他樣式首次都需編輯後才可使用。',
    editContent: '編輯內容',
    cancel: '取消',
    confirm: '確認',
    productMall: '產品商城',
    appointmentService: '預約服務',
    simpleMode: '簡約模式',
    comprehensiveEcommerce: '綜合電商',
    festivalDiscount: '節日優惠',
    dailyNecessities: '日用百貨',
    digitalAppliances: '數碼家電',
    no: '無',
    ordinaryGoods: '普通商品',
    flashSaleGoods: '秒殺商品',
    groupBuyGoods: '拼團商品',
    distributionGoods: '分銷商品',
    businessCardPage: '名片頁',
    mediaPage: '媒體頁',
    mallPage: '商城頁',
    dynamicPage: '動態頁',
    officialWebsitePage: '官網頁',
    templateNeedConfigureContentBeforeSave: '該模板需配置好內容後才可以保存，請點擊"編輯內容"，配置好模板後再保存！',
    uploadCorrectImageFormat: '請上傳正確的圖片格式',
    uploadImageSizeLimit: '上傳圖片大小不能超過10MB哦!',
    saveSuccessful: '保存成功',
  },
  'en': {
    // 授权开关
    forceLoginAuthSwitch: 'Force Login Authorization Switch',
    phoneAuthSwitch: 'Phone Authorization Switch',
    forceLoginAuthDesc: 'After enabling, users who are not logged in need to log in to operate and view page content. Rejecting login will trigger a login authorization pop-up for any operation. In the closed state, users who are not logged in can only view related content of the business card page, and need to log in to authorize to view other pages.',
    phoneAuthDesc: 'After enabling, users who are not logged in need to log in to authorize and authorize their phone number before they can operate and view page content. Rejecting authorization will trigger a phone number authorization pop-up for any operation. In the closed state, users who are not logged in can operate and view page content after logging in.',
    
    // 背景设置
    topBgColorConfig: 'Top Background Color Configuration',
    selectTopBgColor: 'Select Top Background Color',
    defaultBgColorNote: 'Note: The default white background color, black is greater than rgb(30,30,30). White is less than rgb（235,235,235）',
    bgColorNote: 'Except for the "media" page, the top background color of the "business card", "mall", "dynamic", "official website", and "value-added services" pages will be displayed according to the set color.',
    save: 'Save',
    
    // CRM配置
    miniProgramName: 'Mini Program Name',
    appId: 'APPID',
    authTime: 'Authorization Time',
    appName: 'App Name',
    appSecret: 'App Secret',
    pleaseEnterMiniProgramName: 'Please enter the mini-program name',
    pleaseEnterAppId: 'Please enter the mini-program AppId',
    pleaseEnterAppSecret: 'Please enter the mini-program AppSecret',
    miniProgramNameDesc: 'The name of the mini-program (please keep it consistent with the name of the mini-program on the WeChat mini-program platform, enter [Settings] -- [Basic Settings] -- [Mini Program Name] to view)',
    appIdDesc: 'Log in to the mini-program backend (mp.weixin.qq.com), enter [Settings] -- [Development Settings] -- [Development SettingsAppID,wx starts with 18 characters]',
    appSecretDesc: 'Log in to the mini-program backend (mp.weixin.qq.com), enter [Settings] -- [Development Settings] -- [AppSecret (Mini Program Secret)] -- Generate secret key (32 characters)',
    authorization: 'Authorization',
    goToPersonalCenter: 'Please go to the smart business card 【Personal Center】-- 【User ID】',
    userId: 'User ID',
    pleaseEnterUserId: 'Please enter the smart business card user ID',
    confirmSharedCustomers: 'Please confirm that all customers are shared customers before transferring',
    transferDataDesc: 'Currently only supports transferring enterprise information, product information, official website, shared customers. It does not support employee transfer. Employees can only re-join the new mini-program.',
    confirmTransfer: 'Confirm Transfer',
    resetAuthorization: 'Reset Authorization',
    operationSuccess: 'Operation Successful',
    operationFailed: 'Operation Failed',
    crmAuthSuccess: 'crm authorization successful',
    crmAuthFailed: 'crm authorization failed',
    transferSuccess: 'Transfer Successful',
    transferFailed: 'Transfer Failed',
    confirmTransferCompany: 'Are you sure you want to transfer the enterprise to this user?',
    tip: 'Tip',
    confirm: 'Confirm',
    cancel: 'Cancel',
    pleaseEnterUserId: 'Please enter user id',
    notAuthorized: 'Not yet authorized',
    
    // 支付配置
    wechatPayMerchantId: 'WeChat Pay Merchant ID (mchid)',
    apiV2Key: 'APIv2 Key',
    apiV3Key: 'APIv3 Key (Required when using "Business Transfer to Zero Balance" service)',
    certificateSerialNumber: 'Certificate Serial Number (Required when using "Business Transfer to Zero Balance" service)',
    apiCertificate: 'API Certificate (Must be a p12 certificate, generated and obtained from the WeChat Pay merchant backend)',
    pleaseEnterMerchantId: 'Please enter the WeChat Pay merchant ID',
    pleaseEnterApiV2Key: 'Please enter the APIv2 Key',
    pleaseEnterApiV3Key: 'Please enter the APIv3 Key',
    pleaseEnterCertificateSerial: 'Please enter the certificate serial number',
    pleaseUploadApiCertificate: 'Please upload the API certificate',
    clickToUpload: 'Click to upload',
    submitInfo: 'Submit Information',
    deleteInfo: 'Delete Information',
    apiV3KeyDesc: 'The original "Enterprise Payment to Zero Balance" has been upgraded to "Business Transfer to Zero Balance", and new merchants must fill in "APIv3 Key".',
    certificateSerialDesc: 'Log in to the merchant platform [API Security] -> [API Certificate] -> [View Certificate], you can view the merchant API certificate serial number.',
    submitSuccess: 'Submit Successful',
    submitFailed: 'Submit Failed',
    checkDataComplete: 'Please check if the data is complete',
    notSubmittedMerchantInfo: 'WeChat Pay merchant information not yet submitted',
    onlyOneCertificate: 'Only one certificate file can be uploaded',
    
    // 商品列表
    select: 'Select',
    selectGoods: 'Select Goods',
    selectCategory: 'Select Category',
    productName: 'Product Name',
    category: 'Category',
    price: 'Price',
    originalPrice: 'Original Price',
    flashSalePrice: 'Flash Sale Price',
    groupBuyPrice: 'Group Buy Price',
    stock: 'Stock',
    totalSales: 'Total Sales',
    publishTime: 'Publish Time',
    flashSaleTime: 'Flash Sale Time',
    groupBuyTime: 'Group Buy Time',
    serviceMethod: 'Service Method',
    inStore: 'In Store',
    doorToDoor: 'Door to Door',
    inStoreDoorToDoor: 'In Store - Door to Door',
    categoryName: 'Category Name',
    goodsQuantity: 'Goods Quantity',
    noGoods: 'No Goods',
    noCategory: 'No Category',
    needSetGoods: 'Need to Set Goods',
    needSetCategory: 'Need to Set Category',
    goToSet: 'Go to Set',
    cancel: 'Cancel',
    confirm: 'Confirm',
    pleaseSelectGoods: 'Please select the corresponding goods or category',
    sameGoodsError: 'Cannot select the same goods under the same module, please re-select',
    
    // 跳转设置
    jumpTo: 'Jump to',
    pleaseSelect: 'Please select',
    no: 'No',
    goodsCategory: 'Goods Category',
    ordinaryGoods: 'Ordinary Goods',
    flashSaleGoods: 'Flash Sale Goods',
    groupBuyGoods: 'Group Buy Goods',
    distributionGoods: 'Distribution Goods',
    appointmentGoods: 'Appointment Goods',
    businessCardPage: 'Business Card Page',
    mediaPage: 'Media Page',
    mallPage: 'Mall Page',
    dynamicPage: 'Dynamic Page',
    officialWebsitePage: 'Official Website Page',
    valueAddedServicesPage: 'Value-added Services Page',
    categoryNameLabel: 'Category Name:',
    goodsQuantityLabel: 'Goods Quantity:',
    goodsNameLabel: 'Goods Name:',
    appointmentPriceLabel: 'Appointment Price:',
    goodsPriceLabel: 'Goods Price:',
    
    // 公众号配置
    officialAccountName: 'Official Account Name',
    pleaseEnterOfficialAccountName: 'Please enter the official account name',
    pleaseEnterOfficialAccountAppId: 'Please enter the official account AppId',
    pleaseEnterOfficialAccountAppSecret: 'Please enter the official account AppSecret',
    officialAccountNameDesc: 'The name of the official account (please keep it consistent with the name of the official account on the WeChat official account platform, enter [Settings] -- [Basic Settings] -- [Official Account Name] to view)',
    officialAccountAppIdDesc: 'Log in to the official account backend (mp.weixin.qq.com), enter [Settings and Development] -- [Basic Configuration] -- [Official Account Development Information] -- [Developer ID (AppID), wx starts with 18 characters]',
    officialAccountAppSecretDesc: 'Log in to the official account backend (mp.weixin.qq.com), enter [Settings and Development] -- [Basic Configuration] -- [Official Account Development Information] -- [Developer Password (AppSecret)] -- After generation, copy and save the secret key (32 characters)',
    submit: 'Submit',
    checkDataComplete: 'Please check if the data is complete',
    submitSuccess: 'Submit Successful',
    notAuthorized: 'Not yet authorized',
    
    // 企业微信配置
    enterpriseWeChatAuthProcess: 'Enterprise WeChat Authorization Process',
    enterpriseWeChatAuthStep1: '① Fill in the relevant enterprise WeChat configuration information here.',
    enterpriseWeChatAuthStep2: '② After successful authorization, click "Scan and Authorize", use the authorized enterprise WeChat to scan and install the third-party application (scan and authorize).',
    enterpriseWeChatAuthStep3: '③ After installation, click "Import WeChat Organization Structure" in "Enterprise Management" -- "Enterprise Members" -- "Department Settings" to import the enterprise WeChat organization structure information (enterprise WeChat members who do not have a business card in the system cannot be imported into the business card system).',
    configName: 'Configuration Name',
    enterpriseId: 'Enterprise ID',
    appSecret: 'Application Secret',
    authStatus: 'Authorization Status',
    createTime: 'Create Time',
    authorized: 'Authorized',
    notAuthorized: 'Not Authorized',
    pleaseEnterConfigName: 'Please enter the configuration name',
    pleaseEnterEnterpriseId: 'Please enter the enterprise ID',
    pleaseEnterAppSecret: 'Please enter the self-built application secret',
    configNameDesc: 'Log in to the enterprise WeChat (work.weixin.qq.com), enter [My Enterprise] -- [Enterprise Information] -- [The enterprise ID at the bottom of the enterprise information, starting with ww 18 characters]',
    appSecretDesc: 'Log in to the enterprise WeChat (work.weixin.qq.com), enter [Application Management] -- [Self-built] -- [Create Application] -- [Enter the created application] -- [Secret] -- [View]',
    save: 'Save',
    reauthorize: 'Re-authorize',
    resetConfig: 'Reset Configuration',
    resetEnterpriseWeChatInfo: 'Whether to reset enterprise WeChat information',
    resetEnterpriseWeChatDesc: 'After resetting, you need to reconfigure the enterprise WeChat information',
    resetSuccess: 'Reset Successful!',
    resetFailed: 'Reset Failed, please try again later',
    
    // 标签设置
    wechatMiniProgramMechanism: 'Due to the WeChat mini-program mechanism, after changing the content, you need to submit the mini-program for review, and it will take effect after release.',
    navigationModule: 'Navigation Module',
    name: 'Name',
    iconStyle: 'Icon Style',
    unselectedState: 'Unselected State',
    selectedState: 'Selected State',
    suggestUploadIcon: 'It is recommended to upload an icon of 81px * 81px',
    displayPage: 'Display Page',
    addNavigationTemplate: 'Add Navigation Template',
    saveTab: 'Save',
    businessCard: 'Business Card',
    media: 'Media',
    mall: 'Mall',
    dynamic: 'Dynamic',
    officialWebsite: 'Official Website',
    valueAddedServices: 'Value-added Services',
    navigationInfoIncomplete: 'Navigation bar information is incomplete, please confirm!',
    minTwoNavigation: 'The mini-program needs at least two navigation bars!',
    maxFiveNavigation: 'The mini-program can have up to five navigation bars!',
    uploadCorrectImageFormat: 'Please upload the correct image format',
    uploadImageSizeLimit: 'The image size cannot exceed 10MB!',
    
    // 用户支付
    wechatPayMerchantId: 'WeChat Pay Merchant ID (mchid)',
    apiV2Key: 'APIv2 Key',
    apiCertificate: 'API Certificate (Must be a p12 certificate, generated and obtained from the WeChat Pay merchant backend)',
    pleaseEnterMerchantId: 'Please enter the WeChat Pay merchant ID',
    pleaseEnterApiV2Key: 'Please enter the APIv2 Key',
    pleaseUploadApiCertificate: 'Please upload the API certificate',
    clickToUpload: 'Click to upload',
    submitInfo: 'Submit Information',
    deleteInfo: 'Delete Information',
    onlyOneCertificate: 'Only one certificate file can be uploaded',
    checkDataComplete: 'Please check if the data is complete',
    submitSuccess: 'Submit Successful',
    submitFailed: 'Submit Failed',
    notSubmittedMerchantInfo: 'WeChat Pay merchant information not yet submitted',
    
    // 用户终端
    miniProgramName: 'Mini Program Name',
    appName: 'App Name',
    pleaseEnterMiniProgramName: 'Please enter the mini-program name',
    pleaseEnterAppId: 'Please enter the mini-program AppId',
    pleaseEnterAppSecret: 'Please enter the mini-program AppSecret',
    miniProgramNameDesc: 'The name of the mini-program (please keep it consistent with the name of the mini-program on the WeChat mini-program platform, enter [Settings] -- [Basic Settings] -- [Mini Program Name] to view)',
    appIdDesc: 'Log in to the mini-program backend (mp.weixin.qq.com), enter [Settings] -- [Development Settings] -- [Development SettingsAppID,wx starts with 18 characters]',
    appSecretDesc: 'Log in to the mini-program backend (mp.weixin.qq.com), enter [Settings] -- [Development Settings] -- [AppSecret (Mini Program Secret)] -- Generate secret key (32 characters)',
    authorization: 'Authorization',
    userEndAuthSuccess: 'User-side authorization successful',
    userEndAuthFailed: 'User-side authorization failed',
    notAuthorized: 'Not yet authorized',
    
    // 模板相关
    select: 'Select',
    selectGoods: 'Select Goods',
    selectCategory: 'Select Category',
    productName: 'Product Name',
    category: 'Category',
    price: 'Price',
    originalPrice: 'Original Price',
    flashSalePrice: 'Flash Sale Price',
    groupBuyPrice: 'Group Buy Price',
    stock: 'Stock',
    totalSales: 'Total Sales',
    publishTime: 'Publish Time',
    flashSaleTime: 'Flash Sale Time',
    groupBuyTime: 'Group Buy Time',
    serviceMethod: 'Service Method',
    inStore: 'In Store',
    doorToDoor: 'Door to Door',
    inStoreDoorToDoor: 'In Store - Door to Door',
    categoryName: 'Category Name',
    goodsQuantity: 'Goods Quantity',
    noGoods: 'No Goods',
    noCategory: 'No Category',
    needSetGoods: 'Need to Set Goods',
    needSetCategory: 'Need to Set Category',
    goToSet: 'Go to Set',
    cancel: 'Cancel',
    confirm: 'Confirm',
    pleaseSelectGoods: 'Please select the corresponding goods or category',
    sameGoodsError: 'Cannot select the same goods under the same module, please re-select',
    
    // 跳转设置
    jumpTo: 'Jump to',
    pleaseSelect: 'Please select',
    no: 'No',
    goodsCategory: 'Goods Category',
    ordinaryGoods: 'Ordinary Goods',
    flashSaleGoods: 'Flash Sale Goods',
    groupBuyGoods: 'Group Buy Goods',
    distributionGoods: 'Distribution Goods',
    appointmentGoods: 'Appointment Goods',
    businessCardPage: 'Business Card Page',
    mediaPage: 'Media Page',
    mallPage: 'Mall Page',
    dynamicPage: 'Dynamic Page',
    officialWebsitePage: 'Official Website Page',
    valueAddedServicesPage: 'Value-added Services Page',
    categoryNameLabel: 'Category Name:',
    goodsQuantityLabel: 'Goods Quantity:',
    goodsNameLabel: 'Goods Name:',
    appointmentPriceLabel: 'Appointment Price:',
    goodsPriceLabel: 'Goods Price:',
    
    // 倒计时
    day: 'Day',
    hour: 'Hour',
    minute: 'Minute',
    second: 'Second',
    
    // 模板模块
    groupModule: 'Group Buy Module',
    selectedModule: 'Selected Module',
    seckillModule: 'Seckill Module',
    categoryModule: 'Category Module',
    demoGoodsNote: '(The goods shown in the figure are demonstration goods, please change the relevant goods)',
    moduleName: 'Module Name',
    goods: 'Goods',
    goodsName: 'Goods Name',
    goodsPrice: 'Goods Price',
    goodsImage: 'Goods Image',
    goodsDescription: 'Goods Description',
    pleaseEnterContent: 'Please enter content',
    selectGroupGoods: 'Select Group Buy Goods',
    selectSelectedGoods: 'Select Selected Goods',
    selectSeckillGoods: 'Select Seckill Goods',
    
    // 样式设置
    displayStyle: 'Display Style',
    styleSettings: 'Style Settings',
    iconUploadNote: 'Icon upload width of 100*100px is the best effect',
    titleSettings: 'Title Settings',
    jumpSettings: 'Jump Settings',
    iconReset: 'Icon Reset',
    uploadCorrectImageFormat: 'Please upload the correct image format',
    uploadImageSizeLimit: 'The image size cannot exceed 10MB!',
    
    // 错误提示
    seckillMinError: 'Seckill goods cannot be less than three',
    seckillMaxError: 'Seckill goods cannot be more than six',
    goodsAlreadySelected: 'This goods has been selected, please select other goods',
    
    // 新增的键值对
    mobilePhone: 'Mobile Phone',
    tablet: 'Tablet',
    computer: 'Computer',
    camera: 'Camera',
    refrigerator: 'Refrigerator',
    washingMachine: 'Washing Machine',
    kitchenAppliances: 'Kitchen Appliances',
    furniture: 'Furniture',
    television: 'Television',
    airConditioner: 'Air Conditioner',
    businessCard: 'Business Card',
    media: 'Media',
    dynamic: 'Dynamic',
    officialWebsite: 'Official Website',
    personalCare: 'Personal Care',
    householdCleaning: 'Household Cleaning',
    maternalInfant: 'Maternal & Infant',
    protectiveEquipment: 'Protective Equipment',
    homeTextiles: 'Home Textiles',
    leisureSnacks: 'Leisure Snacks',
    limitedTimeFlashSale: 'Limited Time Flash Sale',
    groupBuyRush: 'Group Buy Rush',
    epidemicPreventionMask: 'Epidemic Prevention Mask',
    miniUmbrella: 'Mini Umbrella',
    todayRecommendModule: 'Today\'s Recommendation Module',
    qualityTowel: 'Quality Towel',
    sweepingRobot: 'Sweeping Robot',
    deliciousSnacks: 'Delicious Snacks',
    summerNewTshirt: 'Summer New T-shirt',
    recommendedGoods: 'Recommended Goods',
    superDeliciousSecretRecipeCookies: 'Super Delicious Secret Recipe Cookies',
    broom: 'Broom',
    insStyleWhiteTransparentFairyCurtains: 'INS Style White Transparent Fairy Curtains',
    clothing: 'Clothing',
    pants: 'Pants',
    hat: 'Hat',
    shoes: 'Shoes',
    specialPriceFlashSale: 'Special Price Flash Sale',
    liningChinaLiningShortSleeve: 'Lining China Li-Ning Short Sleeve',
    liningLiningSportsShoes: 'Lining Li-Ning Sports Shoes',
    loosePrintTshirt: 'Loose Print T-shirt',
    qualityRecommendation: 'Quality Recommendation',
    liningHighTopShoes: 'Li-Ning High Top Shoes',
    wearItAndYouWillBeTheMostHandsomeGuy: 'Wear it and you\'ll be the most handsome guy',
    blackTrendyShoes: 'Black Trendy Shoes',
    coolTrendyShoesWorthHavingLightweightComfortableCasualSports: 'Cool trendy shoes worth having, lightweight, comfortable, casual sports',
    restoreDefault: 'Restore Default',
    carousel: 'Carousel',
    imageUploadNote750x324: 'It is recommended to upload 750px * 324px images for best results',
    promotion618: '618',
    midYearPromotion: 'Mid-Year Promotion',
    discountCoupon: 'Discount Coupon',
    discountGoodGiftLimitedTime: 'Discount Good Gifts, Limited Time',
    topsAndOuterwear: 'Tops & Outerwear',
    qualityBags: 'Quality Bags',
    trendyClothing: 'Trendy Clothing',
    jewelry: 'Jewelry',
    officeFurniture: 'Office Furniture',
    deliciousFoodAndWine: 'Delicious Food & Wine',
    booksAndEducation: 'Books & Education',
    beautyAndSkincare: 'Beauty & Skincare',
    topGoods: 'TOP Goods',
    goodGoodsPromotionDirectDiscount: 'Good Goods Promotion, Direct Discount',
    trendyCoat: 'Trendy Coat',
    fashionHat: 'Fashion Hat',
    trendyShortSleeve: 'Trendy Short Sleeve',
    hikingShoes: 'Hiking Shoes',
    newBigBrand: 'NEW Big Brand',
    midYearPromotionGoodThingsAward: 'Mid-Year Promotion, Good Things Award',
    huaweiPhone: 'Huawei Phone',
    fastFaster: 'Fast, Faster',
    superStrongCooling: 'Super Strong Cooling',
    thaiFragrantRice: 'Thai Fragrant Rice',
    deliciousAndAffordable: 'Delicious and Affordable',
    alreadyAtTopCannotMoveUp: 'Already at the top, cannot move up',
    alreadyAtBottomCannotMoveDown: 'Already at the bottom, cannot move down',
    couponNotSet: 'Coupon not set',
    seckillModuleNotSetGoods: 'Seckill module not set goods',
    boutiqueModuleNotSetGoods: 'Boutique module not set goods',
    saveSuccessful: 'Save Successful',
    resetSuccessful: 'Reset Successful!',
    resetFailedPleaseTryAgainLater: 'Reset Failed, please try again later',
    recommendModule: 'Recommend Module',
    leftModule: 'Left Module',
    rightModule: 'Right Module',
    imageUploadNoteSize: 'It is recommended to upload {size}px images for best results',
    hotSaleExplosive: 'Hot Sale Explosive',
    superValueDiscount: 'Super Value Discount',
    today50Off: 'Today 50% Off',
    groupBuyDiscount: 'Group Buy Discount',
    familyEssential: 'Family Essential',
    qualityCamera: 'Quality Camera',
    iphone11: 'iPhone 11',
    xiaomiK40: 'Xiaomi K40',
    phoneCase: 'Phone Case',
    phoneBracelet: 'Phone Bracelet',
    xiaomiRefrigerator: 'Xiaomi Refrigerator',
    router: 'Router',
    diningTable: 'Dining Table',
    qualityBed: 'Quality Bed',
    mallDataIncomplete: 'Mall data incomplete',
    userEnd: 'User End',
    crmEnd: 'CRM End',
    userEndPayment: 'User End Payment',
    crmPayment: 'CRM Payment',
    officialAccountSettings: 'Official Account Settings',
    loginSettings: 'Login Settings',
    enterpriseWeChat: 'Enterprise WeChat',
    resetAuthorizationInfo: 'Reset Authorization Info',
    resetNeedReconfigureMiniProgramInfo: 'After reset, you need to reconfigure the mini program information',
    bottomNavigation: 'Bottom Navigation',
    topBackgroundColorConfig: 'Top Background Color Config',
    
    // 新增的键值对
    moduleDisplay: 'Module Display',
    mallTemplate: 'Mall Template',
    appointmentTemplate: 'Appointment Template',
    canSelectAllOrOnlyShowMallModule: 'Can select all, or only show "Mall Module"',
    mallModule: 'Mall Module',
    moduleName: 'Module Name',
    moduleStyle: 'Module Style',
    currentStyle: 'Current Style',
    changeStyle: 'Change Style',
    topCarousel: 'Top Carousel',
    imageUploadNote750x422: 'It is recommended to upload 750px * 422px images for best results',
    addImage: 'Add Image',
    appointmentModule: 'Appointment Module',
    save: 'Save',
    selectStyle: 'Select Style',
    styleSelectionDescription: 'You can choose any of the following styles to decorate your mall. Except for the simple mode, other styles need to be edited before they can be used for the first time.',
    editContent: 'Edit Content',
    cancel: 'Cancel',
    confirm: 'Confirm',
    productMall: 'Product Mall',
    appointmentService: 'Appointment Service',
    simpleMode: 'Simple Mode',
    comprehensiveEcommerce: 'Comprehensive E-commerce',
    festivalDiscount: 'Festival Discount',
    dailyNecessities: 'Daily Necessities',
    digitalAppliances: 'Digital Appliances',
    no: 'No',
    ordinaryGoods: 'Ordinary Goods',
    flashSaleGoods: 'Flash Sale Goods',
    groupBuyGoods: 'Group Buy Goods',
    distributionGoods: 'Distribution Goods',
    businessCardPage: 'Business Card Page',
    mediaPage: 'Media Page',
    mallPage: 'Mall Page',
    dynamicPage: 'Dynamic Page',
    officialWebsitePage: 'Official Website Page',
    templateNeedConfigureContentBeforeSave: 'This template needs to be configured with content before it can be saved. Please click "Edit Content" to configure the template and then save!',
    uploadCorrectImageFormat: 'Please upload the correct image format',
    uploadImageSizeLimit: 'The image size cannot exceed 10MB!',
    saveSuccessful: 'Save Successful',
  }
}